import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { EndPoints } from "../../../../endPoints/endPoints";
import { IWorkCompleted, IWorkCompletedList, IWorkCompletedNew } from "./IWorksComplited";

export const worksCompletedApi = createApi({
  reducerPath: "works_completed",
  baseQuery: fetchBaseQuery({
    baseUrl: EndPoints.WORKSCOMPLETED,
  }),
  tagTypes: ["works_completed", "work_completed"],
  endpoints: (builder) => ({
    getAllWorksCompleted: builder.query<(IWorkCompletedList)[], number>({
      query(id) {
        return {
          url: `/${id}`,
          method: "GET",
          credentials: "include",
        };
      },
      providesTags: ["works_completed"],
    }),
    addWorkCompleted: builder.mutation<any, IWorkCompletedNew>({
      query(body) {
        return {
          url: "",
          method: "POST",
          credentials: "include",
          body,
        };
      },
      invalidatesTags: ["works_completed"],
    }),
    getWorkCompleted: builder.query<IWorkCompleted, number>({
      query(id) {
        return {
          url: `/${id}`,
          method: "GET",
          credentials: "include",
        };
      },
      providesTags: ["work_completed"],
/*       transformResponse: (response: IFlightFull) => {
        return {
          id: response.id,
          airbase_id: response.airbase.id,
          airbase_name: response.airbase.name,
          contract_id: response.contract.id,
          contract_name: response.contract.name,
          number: response.number,
          application_date: response.application_date,
          date_start: response.date_start,
          date_end: response.date_end,
          duration: response.duration,
          transport_id: response.transport.id,
          transport_name: response.transport.name,
          transport_number: response.transport.number,
        }
      } */
    }),
    editWorkCompleted: builder.mutation<IWorkCompletedNew & {works_completed_id: number}, IWorkCompletedNew & {works_completed_id: number}>({
      query({ works_completed_id, ...body }) {
        return {
          url: `/${works_completed_id}`,
          method: "PUT",
          credentials: "include",
          body,
        };
      },
      invalidatesTags: ["works_completed", "work_completed"],
    }),
    deleteWorkCompleted: builder.mutation<string, number>({
      query(id) {
        return {
          url: `/${id}`,
          method: "DELETE",
          credentials: "include",
        };
      },
      invalidatesTags: ["works_completed"],
    }),
  }),
});

export const {
useAddWorkCompletedMutation,
useDeleteWorkCompletedMutation,
useEditWorkCompletedMutation,
useGetAllWorksCompletedQuery,
useGetWorkCompletedQuery
} = worksCompletedApi;
